module.exports = __webpack_public_path__ + "media/db.22d8cf9f.mp3";